import { useNavigate } from "react-router-dom";
import { MRT_ColumnDef, MRT_RowData } from "material-react-table";
import {
  CustomAutocomplete,
  CustomSearch,
  EstadoComponente,
  GeneralTable,
  SampleTable, SingleButton
} from "@/shared/components/ui";
import {
  useFetchMotivosRechazo,
  useGetSolicitudesIngreso,
  useUpdateSolicitudesIngresos,
} from "@/shared/actions/erp";
import { useCheckPermissions, useTableFilter } from "@/shared/hooks";
import {
  EstadosSolicitudIngresoEnum,
  MotivoRechazo,
  SolicitudesIngreso,
} from "@/shared/interfaces";
import { Grid, TextField } from "@mui/material";
import { useMemo,useState  } from "react";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { useForm } from "react-hook-form";
import { useUiStore } from "@/store/ui";
import PendingActionsIcon from "@mui/icons-material/PendingActions";
import { IUbicacionProducto } from "@/shared/interfaces/erp/inventario";
import { PermissionsEnum } from "@/auth/interfaces";

export default function SolicitudIngresoBodegaAEnEsperaPagina() {
  useCheckPermissions(PermissionsEnum.api_add_solicitudingreso);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const returnUrlSolicitudesIngreso = "/inventario/solicitud-ingreso-inventario";
  const [idEdit, setIdEdit] = useState("");
  const [idEdit2, setIdEdit2] = useState("");
  const [isModalOpen3, setIsModalOpen3] = useState(false);
  const [isModalOpen4, setIsModalOpen4] = useState(false);
  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);
  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  
  const navigate = useNavigate();
  const updateSolicitudesIngreso = useUpdateSolicitudesIngresos({
    navigate,
    returnUrl: returnUrlSolicitudesIngreso
  }
  );
  type SaveFormData = {
    motivo_rechazo?: string;
    detalle: string;
    observacion: string;
  };

  const [details, setDetails] = useState<IUbicacionProducto[]>([]);
  const columns = useMemo<MRT_ColumnDef<SolicitudesIngreso>[]>(
    () => [
      {
        header: "acciones",
        size: 200,
        Cell: ({ row }) => {
          return (
            <>
              <SingleButton
                label="APROBAR"
                variant="text"
                color="success"
                onClick={() => onActions(row.original)}
                startIcon={<PendingActionsIcon />}
              />
              <SingleButton
                label="RECHAZAR"
                variant="text"
                color="error"
                onClick={() => onActions2(row.original)}
                startIcon={<DeleteIcon />}
              />
            </>
          );
        },
      },
      {
        accessorKey: "detalle",
        header: "Detalle",
        size: 200,
        Cell: ({ row }) => {
          return (
            <SingleButton
              label="ver"
              variant="text"
              color="success"
              onClick={() => onDetails(row.original)}
              startIcon={<VisibilityIcon />}
            />
          );
        },
      },
      {
        accessorKey: "fecha_creacion",
        header: "fecha solicitud",
        size: 200,
      },
      {
        accessorKey: "numero_referencia",
        header: "numero referencia",
        size: 200,
      },
      {
        accessorKey: "bodega",
        header: "bodega",
        size: 200,
      },
      {
        accessorKey: "observaciones",
        header: "observaciones",
        size: 200,
      },
      {
        accessorKey: "unidad_transporte",
        header: "unidad transporte",
        size: 200,
      },
      {
        accessorKey: "ubicacion",
        header: "ubicacion",
        size: 200,
      },
      {
        accessorKey: "user.username",
        header: "Usuario",
        size: 200,
      },
      {
        accessorKey: "estado_solicitud",
        header: "estado",
        size: 200,
        Cell: ({ row }) =>
          row.original.estado_solicitud != null ? (
            <EstadoComponente
              backgroundColor="blue"
              texto={row.original.estado_solicitud || ""}
            />
          ) : null,
      },
    ],
    []
  );
  const { data: MotivoRechazoPaging, isLoading: isLoadingMotivoRechazo } =
    useFetchMotivosRechazo({
      page_size: 600,
    });
  const form = useForm<SaveFormData>();
  const {
    register,
    handleSubmit,
    setError,
    control,
    formState: { errors },
  } = form;
  
  const onSaveEdit = handleSubmit((data) => {
    if (idEdit) {
      updateSolicitudesIngreso.mutate(
        {
          id: idEdit!,
          data: {
            estado_solicitud: EstadosSolicitudIngresoEnum.APROBADAS,
            observaciones:{
              observaciones: data.observacion
            }
            //observaciones: data.observacion,
          },
        },
        {
          onSuccess: () => {
            setIsModalOpen3(false);
            setIdEdit("");
            form.reset({ observacion: "" });
            refetch();
          },
          onError: (error) => {
            console.error("Error en la mutación", error);
          },
        }
      );
    }
  });
  function onActions(e: MRT_RowData) {
    setIdEdit(e.id_solicitudingreso);
    setIsModalOpen3(true);
  }
  function onActions2(e: MRT_RowData) {
    setIdEdit2(e.id_solicitudingreso);
    setIsModalOpen4(true);
  }

  ///*fetch

  const onDetails = (e: MRT_RowData) => {
    setDetails(e.productos);
    setIsModalOpen(true);
    setIdEdit(e.id_solicitud_Ingreso);
  };

  const columnsProductosDetallePedidosDb: MRT_ColumnDef<IUbicacionProducto>[] =
    useMemo<MRT_ColumnDef<IUbicacionProducto>[]>(
      () => [
        {
          accessorKey: 'codigo',
          header: 'Código',
          Cell: ({ row }) => row.original?.codigo || 'N/A',
        },
        {
          accessorKey: 'descripcion',
          header: 'Descripción',
          Cell: ({ row }) => row.original?.producto_data?.descripcion ?? 'N/A',
        },

        {
          accessorKey: 'stock_actual',
          header: 'Stock Actual',
          // stock_actual = cantidad transferida
          Cell: ({ row }) => row.original?.producto_data?.stock_actual ?? 'N/A',
        },
        {
          accessorKey: 'producto_data.modelo_producto',
          header: 'Modelo',
        },
        {
          accessorKey: 'producto_data.marca_producto',
          header: 'Marca',
        },
        {
          accessorKey: 'producto_data.categoria_producto',
          header: 'Categoria',
        },
        {
          accessorKey: 'producto_data.unidad_medida',
          header: 'Medida',
        },
      ],
      []
    );

  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    dateBefore,
    dateAfter,
    onChangeRangeDate,
    cleanFilter,

  } = useTableFilter();

  const { pageIndex } = pagination;

  const {
    data: solicitudPedidoIngresosEnesperaRes,
    isLoading,
    isRefetching,
    refetch
  } = useGetSolicitudesIngreso({
    page_size: 600,
    page: pageIndex + 1,
    estado_solicitud: EstadosSolicitudIngresoEnum.ESPERA,
    fecha_after: dateAfter,
    fecha_before: dateBefore,
    numero_referencia: searchTerm,
  });
  const handleConfirm = () => {
    setConfirmDialog({
      isOpen: true,
      subtitle: "¿Está seguro que deseas rechazar la solicitud de Ingreso seleccionada?",
      title: "Confirmar eliminación",
      onConfirm: () => {
        if (idEdit2) {
          updateSolicitudesIngreso.mutate({
            id: idEdit2,
            data: {
              estado_solicitud: EstadosSolicitudIngresoEnum.RECHAZADO,
              motivo_rechazo: form.getValues("motivo_rechazo"),
            },
          }, {
            onSuccess: () => {
              setIsModalOpen4(false);
              setConfirmDialogIsOpen(false);
              setIdEdit("");
              form.reset({ observacion: '' });
              refetch();
            },
            onError: (error) => {
              console.error("Error en la mutación", error);
            }
          });
        } else {
          console.error("idEdit is null");
        }
      },
      onClose() {
        setConfirmDialogIsOpen(false);
        setIdEdit2("");
        form.setValue("motivo_rechazo", "");
        setIsModalOpen4(false);
        refetch();
      },
    });
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <CustomSearch
          onChange={onChangeFilter}
          value={globalFilter}
          text=""
          onChangeRangeDate={onChangeRangeDate}
          cleanFilter={cleanFilter}
        />
      </Grid>
      <Grid item xs={12}>
        <GeneralTable<SolicitudesIngreso>
          columns={columns}
          data={solicitudPedidoIngresosEnesperaRes?.data.data || []}
          //
          isLoading={isLoading}
          isRefetching={isRefetching}
          // // search
          enableGlobalFilter={false}
          // onGlobalFilterChange={setGlobalFilter}
          // // pagination
          pagination={pagination}
          onPaging={setPagination}
          rowCount={solicitudPedidoIngresosEnesperaRes?.data?.count}
          // // actions
          actionsColumnSize={120}
          // crud
          enableColumnActions={false}
          enableEditing={false}
          canDelete={false}
          positionActionsColumn="first"
        />
      </Grid>
      <ScrollableDialogProps
        open={isModalOpen}
        title="Detalles"
        cancelTextBtn="Cerrar"
        onClose={() => setIsModalOpen(false)}
        minWidth="100%"
        contentNode={
            <Grid container spacing={3}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                {details.length > 0 && (
                  <SampleTable<IUbicacionProducto>
                    columns={columnsProductosDetallePedidosDb}
                    data={details}
                  />
                )}
              </Grid>
            </Grid>
        }
      />


      <ScrollableDialogProps
        open={isModalOpen4}
        title="Rechazar la solicitud de Ingreso"
        cancelTextBtn="Cancelar"
        confirmTextBtn="Rechazar"
        contentNode={
            <CustomAutocomplete<MotivoRechazo>
              label="Motivo"
              name="motivo_rechazo"
              // options
              options={(MotivoRechazoPaging?.data.data as any) || []}
              valueKey="nombre" // name is the fk
              actualValueKey="codigo"
              defaultValue={form.getValues().motivo_rechazo || ""}
              isLoadingData={isLoadingMotivoRechazo}
              control={control}
              error={errors.motivo_rechazo}
              helperText={errors.motivo_rechazo?.message}
              onChangeValue={
                (e) => {
                  form.setValue("motivo_rechazo", e);
                }
              }
            />
        }
        onConfirm={() => {
          if (!form.getValues().motivo_rechazo) {
            setError("motivo_rechazo", {
              type: "required",
              message: "El motivo del rechazo es obligatorio"
            });
            return;
          }
          handleConfirm();
        }}
        onClose={() => {
          setIsModalOpen4(false);
          form.reset({ observacion: "" });
        }}
      />

      <ScrollableDialogProps
        open={isModalOpen3}
        title="Aprobar la solicitud de Ingreso"
        confirmTextBtn="Aprobar"
        contentNode={
            <TextField
              {...register("observacion", { required: "La observacion es obligatoria" })}
              id="observacion"
              label="Observación"
              fullWidth
              rows={4}
              multiline
              error={Boolean(errors.observacion)}
              helperText={errors.observacion?.message}
            />
        }
        onConfirm={onSaveEdit}
        onClose={() => {
          setIsModalOpen3(false);
          form.reset({ observacion: "" });
        }}
      />
    </Grid>
  );
}
